import BaseStorageProvider from "./BaseStorageProvider";
import clientErrorLogger from "util/clientErrorLogger";
import { appendQueryParams } from "util/urlUtilities";
import request from "util/chainedRequest";
import isFunction from "lodash/isFunction";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";

export default class FormApiStorageProvider extends BaseStorageProvider {
    constructor(endpoint, deleteEndpoint, formErrorCallback, customSpinnerEvent) {
        super();
        this.formErrorCallback = formErrorCallback;
        this.endpoint = endpoint || "";
        this.deleteEndpoint = deleteEndpoint || "";
        this.deleteEndpointQueryStringArgs = {};
        this.customSpinnerEvent = customSpinnerEvent || null;
    }

    _save(dispatcher, data, callback, errorCallback) {
        if (isEmpty(this.endpoint)) {
            super.save(dispatcher, data, callback);
            return;
        }

        request(dispatcher)
            .withLoadSpinner(this.customSpinnerEvent)
            .post(this.endpoint)
            .set("Content-Type", "application/json")
            .accept("json")
            .send(data)
            .respond()
            .onFormError(null, (err, res, next) => {
                // eslint-disable-line handle-callback-err
                if (isFunction(this.formErrorCallback)) {
                    return this.formErrorCallback(res.body.errors);
                } else {
                    return next();
                }
            })
            .onError((err, res) => {
                let errorMessage = "We're having trouble with your request. Please contact Customer Service.";
                
                // Check for 413 status code (Request Entity Too Large / Payload Too Large)
                const statusCode = res?.status || err?.status || err?.response?.status;
                if (statusCode === 413) {
                    errorMessage = "The uploaded file is too large. Please upload a smaller file.";
                } else if (res?.body?.message) {
                    errorMessage = res.body.message;
                } else if (isString(res?.body?.result)) {
                    errorMessage = res?.body?.result;
                } else if (err?.response?.text) {
                    try {
                        const responseObj = JSON.parse(err.response.text);
                        if (responseObj.message) {
                            errorMessage = responseObj.message;
                        }
                    } catch (e) {
                        // If parsing fails, use default message
                    }
                }
                
                dispatcher.emit("SHOW_FLASH_MESSAGE", {
                    message: errorMessage,
                    className: "error"
                });
                
                if (err?.response?.text) {
                    try {
                        const responseObj = JSON.parse(err.response.text);
                        const message = responseObj.message || "Error";
                        const modelState = responseObj.modelState || "Empty Model State";
                        clientErrorLogger.notify(message, "error", modelState);
                    } catch (e) {
                        // If parsing fails, log the error
                        clientErrorLogger.notify(errorMessage, "error");
                    }
                }
            })
            .onRedirect()
            .handle(callback);
    }

    _delete(dispatcher, callback) {
        if (isEmpty(this.deleteEndpoint)) {
            super.delete(dispatcher, callback);
            return;
        }

        request(dispatcher)
            .withLoadSpinner(this.customSpinnerEvent)
            .del(appendQueryParams(this.deleteEndpoint, this.deleteEndpointQueryStringArgs))
            .respond()
            .onFormError(null, (err, res, next) => { // eslint-disable-line handle-callback-err
                if (isFunction(this.formErrorCallback)) {
                    return this.formErrorCallback(res.body.errors);
                } else {
                    return next();
                }
            })
            .onError((err, res) => { // eslint-disable-line handle-callback-err
                dispatcher.emit("SHOW_FLASH_MESSAGE", {
                    message: "An internal error occurred.",
                    className: "warning"
                });
            })
            .onRedirect()
            .handle(callback);
    }
}
